import firebaseApp from '../../utils/firebase'

export default {
  postNotify({
    getters
  }, {
    sender,
    session,
    receiver,
    code,
    expiryDuration
  }) {

    let sessionData = getters.getSession || {}

    sender = sender || getters.getUID
    session = session || getters.bindSID
    receiver = receiver || sessionData.agent || sessionData.team || getters.getOrgId
    code = code || 1
    expiryDuration = expiryDuration || 86400000

    const id = [sender, code, session].join('|')
    const now = Date.now()

    if (sender)
      firebaseApp.ref.child('notifications')
        .child('data')
        .child(receiver)
        .child(id)
        .transaction((data) => {
          return {
            created_at: now,
            expires_at: now + expiryDuration,
            count: data === null ? 1 : data.count + 1
          }
        })

  }

}
